import React from 'react';
export function UploadIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.309 7.015A6.98 6.98 0 004.1 11.112 4 4 0 005 19h2a1 1 0 000-2H5a2 2 0 111.413-3.413 1 1 0 001.414-1.414 3.964 3.964 0 00-1.665-.982A4.815 4.815 0 016 10.001a4.99 4.99 0 019.182-2.715 5.915 5.915 0 00-2.936 2.057 1 1 0 001.588 1.214A3.956 3.956 0 0117 9a4 4 0 110 8 1 1 0 100 2 6 6 0 00.309-11.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.707 13.293a1 1 0 00-1.414 0l-2 2a1 1 0 001.414 1.414l.293-.293V20a1 1 0 102 0v-3.586l.293.293a1 1 0 001.414-1.414l-2-2z"
  }));
}